import { GridItem } from 'foundations-components/transitional/components/Grid';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { useDetailsConfiguredTicketProperty } from '../../utils/useDetailsConfiguredTicketProperty';
import { FavoriteHollowIcon } from 'foundations-assets/icons/components/FavoriteHollowIcon';
import { ICONS } from '../../constants/configuredProperties';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { getIsPreview } from '../../utils/isPreview';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const InfoGridRow = ({
  configuredTicketProperty
}) => {
  const {
    propertyDisplayName,
    formattedPropertyValue
  } = useDetailsConfiguredTicketProperty(configuredTicketProperty.propertyName);
  const {
    isPreview
  } = getIsPreview();
  const Icon = ICONS[configuredTicketProperty.propertyName] || FavoriteHollowIcon;
  const hasValue = formattedPropertyValue != null;
  return (hasValue || isPreview) && /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(GridItem, {
      size: 6,
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        gap: "200",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Flex, {
          flexShrink: "0",
          children: /*#__PURE__*/_jsx(Icon, {
            size: "300"
          })
        }), /*#__PURE__*/_jsx(Text, {
          as: "div",
          typography: "body-100",
          marginBlockEnd: "0",
          truncate: true,
          children: /*#__PURE__*/_jsx(TruncateString, {
            children: propertyDisplayName
          })
        })]
      })
    }), /*#__PURE__*/_jsx(GridItem, {
      size: 6,
      children: /*#__PURE__*/_jsx(Text, {
        as: "div",
        typography: "body-100",
        marginBlockEnd: "0",
        children: hasValue ? formattedPropertyValue : '—'
      })
    })]
  });
};